import ActiveLink from "../shared/active-link-app"
const communities = [
  { name: 'Order', href: '/help' },
  { name: 'Shipping', href: '/help/shipping' },
]

export default function SizeBar() {
  return (
    <nav aria-label="Sidebar" className="sticky top-10 divide-y divide-gray-300">
      <div className="">
        <p className="px-3 text-md font-medium text-gray-500" id="communities-headline">
          Topics
        </p>
        <div className="mt-3 space-y-2" aria-labelledby="communities-headline">
          {communities.map((community) => (
            <ActiveLink
              key={community.name}
              href={community.href}
              activeClassName="text-blue-600 bg-gray-50"
              className="group flex items-center rounded-md px-3 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 hover:text-gray-900"
            >
              <span className="truncate">{community.name}</span>
            </ActiveLink>
          ))}
        </div>
      </div>
    </nav>
  )
}